module.exports = __webpack_public_path__ + "static/media/00553ce0b224cdeb1269bc2c756d8775c0b21a9f-24x24.0307ef26.png";